export const CULTURE_ITEMS = [
  {
    title: "Classical Dance",
    hindi: "शास्त्रीय नृत्य",
    text: "Bharatanatyam, Kathak, Odissi, Kathakali, Kuchipudi, Manipuri, Mohiniyattam and Sattriya: eight classical forms, each a living scripture.",
    image: "https://images.unsplash.com/photo-1756370256926-e48ca54c5efe?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    tone: "saffron",
  },
  {
    title: "Festivals of Light & Colour",
    hindi: "त्योहार",
    text: "Diwali lamps, Holi colours, Eid feasts, Christmas carols in Goa, Pongal pots and Bihu drums. Every month, somewhere in India, a festival begins.",
    image: "https://images.unsplash.com/photo-1616787671779-eed71117a65e?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    tone: "green",
  },
  {
    title: "Temples, Mosques & Monuments",
    hindi: "विरासत",
    text: "From the rock-cut caves of Ajanta to the Taj Mahal and the Golden Temple, forty-plus UNESCO sites tell a story five millennia long.",
    image: "https://images.unsplash.com/photo-1564507592333-c60657eea523?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    tone: "chakra",
  },
  {
    title: "Crafts & Textiles",
    hindi: "हस्तकला",
    text: "Banarasi silk, Kanjeevaram, Pashmina, Madhubani painting, Bidriware and Channapatna toys: hands that have carried skill for generations.",
    image: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
    tone: "saffron",
  },
];

export const DIVERSITY_STATS = [
  { value: "28", label: "States", hindi: "राज्य" },
  { value: "8", label: "Union Territories", hindi: "केंद्र शासित प्रदेश" },
  { value: "22", label: "Scheduled Languages", hindi: "भाषाएँ" },
  { value: "1.4B", label: "People, one nation", hindi: "लोग" },
];

export const REGIONS = [
  { name: "North", states: "Punjab, Haryana, Himachal, Uttarakhand, Delhi, J&K, Ladakh", flavour: "Bhangra, Himalayan monasteries, wheat fields and the Golden Temple.", color: "#ff9933" },
  { name: "West", states: "Rajasthan, Gujarat, Maharashtra, Goa", flavour: "Desert forts, Garba nights, Mumbai's hustle and Goan beaches.", color: "#138808" },
  { name: "South", states: "Kerala, Tamil Nadu, Karnataka, Andhra, Telangana", flavour: "Backwaters, Dravidian temples, filter coffee and Carnatic music.", color: "#0b3d91" },
  { name: "East", states: "West Bengal, Odisha, Bihar, Jharkhand", flavour: "Durga Puja, Konark's sun chariot, Mithila art and Bodh Gaya.", color: "#ff9933" },
  { name: "North-East", states: "Assam, Meghalaya, Manipur, Nagaland, Tripura, Mizoram, Arunachal, Sikkim", flavour: "Living root bridges, Hornbill festival, tea gardens and Kaziranga.", color: "#138808" },
  { name: "Central", states: "Madhya Pradesh, Chhattisgarh, Uttar Pradesh", flavour: "Khajuraho, Varanasi ghats, tiger reserves and the Ganga.", color: "#0b3d91" },
];

export const LANGUAGES = ["हिन्दी", "বাংলা", "తెలుగు", "मराठी", "தமிழ்", "ગુજરાતી", "ಕನ್ನಡ", "ଓଡ଼ିଆ", "മലയാളം", "ਪੰਜਾਬੀ", "অসমীয়া", "اردو", "मैथिली", "संस्कृतम्", "कोंकणी", "नेपाली", "ᱥᱟᱱᱛᱟᱲᱤ", "डोगरी", "কোকবোৰোক", "سنڌي", "कश्मीरी", "ꯃꯤꯇꯩꯂꯣꯟ"];

export const GROWTH_MILESTONES = [
  { year: "1947", title: "Independence", text: "A new republic is born, the world's largest democratic experiment begins." },
  { year: "1969", title: "ISRO founded", text: "From carrying rocket parts on bicycles to a space agency the world respects." },
  { year: "1991", title: "Economic reforms", text: "Liberalisation opens the economy and unleashes a generation of entrepreneurs." },
  { year: "2016", title: "UPI launched", text: "Instant, free digital payments for every Indian, now 15+ billion transactions a month." },
  { year: "2023", title: "Chandrayaan-3", text: "First nation to land near the Moon's south pole, on a frugal budget." },
  { year: "2030s", title: "Viksit Bharat", text: "Towards a developed India: green energy, semiconductors, Gaganyaan and beyond." },
];

export const GROWTH_STATS = [
  { value: "5th", label: "Largest economy in the world", tone: "saffron" },
  { value: "15B+", label: "UPI transactions every month", tone: "chakra" },
  { value: "1.46L km", label: "National highway network", tone: "green" },
  { value: "180 GW+", label: "Renewable energy capacity", tone: "green" },
];

export const GEOPOLITICS_ITEMS = [
  { title: "Strategic Autonomy", hindi: "रणनीतिक स्वायत्तता", text: "Multi-alignment, not non-alignment: QUAD, BRICS, SCO and G20 on India's own terms.", tone: "chakra" },
  { title: "Indo-Pacific & QUAD", hindi: "हिंद-प्रशांत", text: "A free, open Indo-Pacific anchored by the Indian Navy from Aden to Malacca.", tone: "saffron" },
  { title: "Neighbourhood First", hindi: "पड़ोसी प्रथम", text: "Bhutan, Nepal, Sri Lanka, Bangladesh, Maldives: stability begins at the border.", tone: "green" },
  { title: "Act East", hindi: "एक्ट ईस्ट", text: "ASEAN partnerships, the Kaladan corridor and the North-East as India's gateway to Asia.", tone: "chakra" },
  { title: "Border & Security", hindi: "सीमा और सुरक्षा", text: "Ladakh to Arunachal: roads, tunnels and Atmanirbhar defence that back words with steel.", tone: "saffron" },
  { title: "Voice of the Global South", hindi: "ग्लोबल साउथ", text: "Vaccine Maitri, the African Union into the G20, and the IMEC corridor to Europe.", tone: "green" },
];
